module.exports = __webpack_public_path__ + "img/airdrop_bg.78034216.png";